import { MessageSquareDiff } from 'lucide-react';

const Add = () => {
  return (
    <MessageSquareDiff />
  );
};

export default Add;
